/* Letreiro LED - Aniversario: remove o letreiro se a pagina veio de cache fora do periodo. */
(function () {
  function check() {
    var now = Date.now();
    document.querySelectorAll('[data-nv-led]').forEach(function (el) {
      var start = parseInt(el.getAttribute('data-start'), 10) * 1000;
      var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
      if ((end && now > end) || (start && now < start)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
